import { SHOW_GUIDANCE } from '../actions/users'

function guidanceReducer(state = false, action) {
  switch (action.type) {
    case SHOW_GUIDANCE:
      return !state
    default:
      return state
  }
}

export default guidanceReducer
